import Swiper from 'swiper';
import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";
import { Navigation, Scrollbar, Pagination } from 'swiper/modules';

export default function gallery() {
  galleryPhotoSwipe().init();
  gallerySlider();
}

export function gallerySlider() {
  const swiperContainer = document.querySelector('.post-footer__gallery-container.swiper') as HTMLElement;
  const prevEl = swiperContainer?.querySelector('.swiper-button-prev') as HTMLElement;
  const nextEl = swiperContainer?.querySelector('.swiper-button-next') as HTMLElement;
  const pagination = swiperContainer?.querySelector('.swiper-pagination') as HTMLElement;
  const scrollbar = swiperContainer?.querySelector('.swiper-scrollbar') as HTMLElement;

  new Swiper(swiperContainer, {
    modules: [Navigation, Scrollbar, Pagination],
    slidesPerView: 1,
    spaceBetween: 24,
    rewind: true,
    navigation: {
      prevEl,
      nextEl
    },
    scrollbar: {
      el: scrollbar,
      draggable: true,
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 4,
        pagination: {
          el: pagination,
          clickable: true,
        },
      }
    }
  })
}

export function galleryPhotoSwipe() {
  return new PhotoSwipeLightbox({
    gallery: '.post-footer__gallery-container',
    children: 'a',
    pswpModule: () => PhotoSwipe,
    showHideAnimationType: 'fade',
    wheelToZoom: true,
    counter: false,
    padding: {
      top: 20,
      bottom: 40,
      left: 100,
      right: 100
    }
  })
}